import * as React from "react";
import { RoundDefaultBtn } from "../../../assets/svg/RoundDefaultBtn";
import { IdOrientation } from "../../../constants/IdOrientation";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
import { SvgButton } from "../svg-button/SvgButton";
export var ButtonPaymentSelectPagerRight = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (React.createElement(SvgButton, { name: IdStyles.DefaultRoundBtn, svg: RoundDefaultBtn, onClick: onClick },
        React.createElement("div", { className: "flex flex--guts h100" },
            React.createElement(Icon, { icon: IdIcon.WhiteArrowIcn, styleId: IdStyles.IconSmall, orientation: IdOrientation.Right }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/common/ButtonPaymentSelectPagerRight.tsx
// module id = 2923
// module chunks = 3